<template>
  <div class="how-it-works">
    <div class="container">
      <div class="change-block">
        <div class="title">{{ $t('howItWorks.titulo') }}</div>
        <div class="bg-block">
          <img v-show="defaultSize && !smalltSize" src="../assets/bg-change-block.png" alt="">
          <img v-show="!defaultSize && !smalltSize" src="../assets/bg-change-block-small2.png" alt="">
          <img v-show="smalltSize" src="../assets/bg-change-block-very-small.png" alt="">
        </div>
        <div class="content-block">
          <div class="left-block">
            <div :class="{'active': temporalVisibleBlock === 1}" class="floating-select-block floating-1" @click="changeVisibleBlock(1)"><i class="fas fa-video"></i><span>{{ $t('howItWorks.bloque1.boton') }}</span></div>
            <div :class="{'active': temporalVisibleBlock === 2}" class="floating-select-block floating-2" @click="changeVisibleBlock(2)"><i class="fas fa-wifi"></i><span>{{ $t('howItWorks.bloque2.boton') }}</span></div>
            <div :class="{'active': temporalVisibleBlock === 3}" class="floating-select-block floating-3" @click="changeVisibleBlock(3)"><i class="fas fa-star"></i><span>{{ $t('howItWorks.bloque3.boton') }}</span></div>
          </div>
          <div class="center-block">
            <!-- FONDOS -> ES  -->
            <img v-show="visibleBlock === 1 && getLanguage === 'es'" :class="{'animatedImgShow': visibleBlock === 1, 'animatedImgHide': oldVisibleBlock === 1}" src="../assets/how-it-works/screen-1-es.png" alt="" />
            <img v-show="visibleBlock === 2 && getLanguage === 'es'" :class="{'animatedImgShow': visibleBlock === 2, 'animatedImgHide': oldVisibleBlock === 2}" src="../assets/how-it-works/screen-2-es.png" alt="" />
            <img v-show="visibleBlock === 3 && getLanguage === 'es'" :class="{'animatedImgShow': visibleBlock === 3, 'animatedImgHide': oldVisibleBlock === 3}" src="../assets/how-it-works/screen-3-es.png" alt="" />
            <img v-show="visibleBlock === 4 && getLanguage === 'es'" :class="{'animatedImgShow': visibleBlock === 4, 'animatedImgHide': oldVisibleBlock === 4}" src="../assets/how-it-works/screen-4-es.png" alt="" />
            <img v-show="visibleBlock === 5 && getLanguage === 'es'" :class="{'animatedImgShow': visibleBlock === 5, 'animatedImgHide': oldVisibleBlock === 5}" src="../assets/how-it-works/screen-5-es.png" alt="" />

            <!-- FONDOS -> EN  -->
            <img v-show="visibleBlock === 1 && getLanguage !== 'es'" :class="{'animatedImgShow': visibleBlock === 1, 'animatedImgHide': oldVisibleBlock === 1}" src="../assets/how-it-works/screen-1-en.png" alt="" />
            <img v-show="visibleBlock === 2 && getLanguage !== 'es'" :class="{'animatedImgShow': visibleBlock === 2, 'animatedImgHide': oldVisibleBlock === 2}" src="../assets/how-it-works/screen-2-en.png" alt="" />
            <img v-show="visibleBlock === 3 && getLanguage !== 'es'" :class="{'animatedImgShow': visibleBlock === 3, 'animatedImgHide': oldVisibleBlock === 3}" src="../assets/how-it-works/screen-3-en.png" alt="" />
            <img v-show="visibleBlock === 4 && getLanguage !== 'es'" :class="{'animatedImgShow': visibleBlock === 4, 'animatedImgHide': oldVisibleBlock === 4}" src="../assets/how-it-works/screen-4-en.png" alt="" />
            <img v-show="visibleBlock === 5 && getLanguage !== 'es'" :class="{'animatedImgShow': visibleBlock === 5, 'animatedImgHide': oldVisibleBlock === 5}" src="../assets/how-it-works/screen-5-en.png" alt="" />

            <!-- BLOCK 1 -->
            <div v-show="visibleBlock === 1" :class="{'animatedShow': visibleBlock === 1, 'animatedHide': oldVisibleBlock === 1}" class="selected-block-text">
              <div class="icon mb-20"><i class="fas fa-video text-verde fs-25"></i></div>
              <div class="title mb-25 text-azul fs-20"><strong>{{ $t('howItWorks.bloque1.titulo') }}</strong></div>
              <div class="content">
                <div class="separated-block">
                  <i class="fas fa-square-full text-verde"></i>
                  <span>{{ $t('howItWorks.bloque1.dato1') }}</span>
                </div>
                <div class="separated-block">
                  <i class="fas fa-square-full text-verde"></i>
                  <span>{{ $t('howItWorks.bloque1.dato2') }}</span>
                </div>
              </div>
            </div>

            <!-- BLOCK 2 -->
            <div v-show="visibleBlock === 2" :class="{'animatedShow': visibleBlock === 2, 'animatedHide': oldVisibleBlock === 2}" class="selected-block-text">
              <div class="icon mb-20"><i class="fas fa-wifi text-verde fs-25"></i></div>
              <div class="title mb-25 text-azul fs-20"><strong>{{ $t('howItWorks.bloque2.titulo') }}</strong></div>
              <div class="content">
                <div class="separated-block">
                  <i class="fas fa-square-full text-verde"></i>
                  <span>{{ $t('howItWorks.bloque2.dato1') }}</span>
                </div>
                <div class="separated-block">
                  <i class="fas fa-square-full text-verde"></i>
                  <span>{{ $t('howItWorks.bloque2.dato2') }}</span>
                </div>
              </div>
            </div>

            <!-- BLOCK 3 -->
            <div v-show="visibleBlock === 3" :class="{'animatedShow': visibleBlock === 3, 'animatedHide': oldVisibleBlock === 3}" class="selected-block-text">
              <div class="icon mb-20"><i class="fas fa-star text-verde fs-25"></i></div>
              <div class="title mb-25 text-azul fs-20"><strong>{{ $t('howItWorks.bloque3.titulo') }}</strong></div>
              <div class="content">
                <div class="separated-block">
                  <i class="fas fa-square-full text-verde"></i>
                  <span>{{ $t('howItWorks.bloque3.dato1') }}</span>
                </div>
              </div>
            </div>

            <!-- BLOCK 4 -->
            <div v-show="visibleBlock === 4" :class="{'animatedShow': visibleBlock === 4, 'animatedHide': oldVisibleBlock === 4}" class="selected-block-text">
              <div class="icon mb-20"><i class="fas fa-mobile-alt text-verde fs-25"></i></div>
              <div class="title mb-25 text-azul fs-20"><strong>{{ $t('howItWorks.bloque4.titulo') }}</strong></div>
              <div class="content">
                <div class="separated-block">
                  <i class="fas fa-square-full text-verde"></i>
                  <span>{{ $t('howItWorks.bloque4.dato1') }}</span>
                </div>
                <div class="separated-block">
                  <i class="fas fa-square-full text-verde"></i>
                  <span>{{ $t('howItWorks.bloque4.dato2') }}</span>
                </div>
              </div>
            </div>

            <!-- BLOCK 5 -->
            <div v-show="visibleBlock === 5" :class="{'animatedShow': visibleBlock === 5, 'animatedHide': oldVisibleBlock === 5}" class="selected-block-text">
              <div class="icon mb-20"><i class="far fa-globe-americas text-verde fs-25"></i></div>
              <div class="title mb-25 text-azul fs-20"><strong>{{ $t('howItWorks.bloque5.titulo') }}</strong></div>
              <div class="content">
                <div class="separated-block">
                  <i class="fas fa-square-full text-verde"></i>
                  <span>{{ $t('howItWorks.bloque5.dato1') }}</span>
                </div>
              </div>
            </div>

            <img v-show="defaultSize" src="../assets/top-phone-works.png" class="top-mask" alt="" />
            <img v-show="!defaultSize" src="../assets/top-phone-works-small.png" class="top-mask" alt="" />
          </div>
          <div class="right-block">
            <div :class="{'active': temporalVisibleBlock === 4}" class="floating-select-block floating-4" @click="changeVisibleBlock(4)"><i class="fas fa-mobile-alt"></i><span>{{ $t('howItWorks.bloque4.boton') }}</span></div>
            <div :class="{'active': temporalVisibleBlock === 5}" class="floating-select-block floating-5" @click="changeVisibleBlock(5)"><i class="far fa-globe-americas"></i><span>{{ $t('howItWorks.bloque5.boton') }}</span></div>
          </div>
        </div>
        <div v-if="!defaultSize" class="bottom-block">
          <i :class="{'active': temporalVisibleBlock === 1}" class="fas fa-circle text-verde fs-16 cursor-pointer" @click="changeVisibleBlock(1)"></i>
          <i :class="{'active': temporalVisibleBlock === 2}" class="fas fa-circle text-verde fs-16 cursor-pointer" @click="changeVisibleBlock(2)"></i>
          <i :class="{'active': temporalVisibleBlock === 3}" class="fas fa-circle text-verde fs-16 cursor-pointer" @click="changeVisibleBlock(3)"></i>
          <i :class="{'active': temporalVisibleBlock === 4}" class="fas fa-circle text-verde fs-16 cursor-pointer" @click="changeVisibleBlock(4)"></i>
          <i :class="{'active': temporalVisibleBlock === 5}" class="fas fa-circle text-verde fs-16 cursor-pointer" @click="changeVisibleBlock(5)"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import i18n from '../plugins/i18n.js'
export default {
  name: 'HowItWorks',
  data: () => ({
    visibleBlock: 1,
    oldVisibleBlock: 0,
    temporalVisibleBlock: 1,
    defaultSize: true,
    smalltSize: false,
    fnInterval: {}
  }),
  created () {
    window.addEventListener('resize', this.checkBackgroundSize)
    this.checkBackgroundSize()
    this.initInterval()
  },
  computed: {
    getLanguage () {
      return i18n.locale
    }
  },
  methods: {
    changeVisibleBlock (index) {
      clearInterval(this.fnInterval)
      this.initInterval()
      this.temporalVisibleBlock = index
      this.oldVisibleBlock = this.visibleBlock
      setTimeout(() => {
        this.visibleBlock = index
      }, 1500)
    },
    checkBackgroundSize () {
      if (window.innerWidth > 870 && !this.defaultSize) {
        this.defaultSize = true
        this.smalltSize = false
      }
      if (window.innerWidth <= 870 && this.defaultSize) {
        this.defaultSize = false
        this.smalltSize = false
      }
      if (window.innerWidth <= 400 && !this.smalltSize) {
        this.smalltSize = true
      }
    },
    initInterval () {
      this.fnInterval = setInterval(() => {
        let saved = false
        if (this.temporalVisibleBlock < 5 && !saved) {
          this.changeVisibleBlock(this.temporalVisibleBlock + 1)
          saved = true
        }
        if (this.temporalVisibleBlock === 5 && !saved) {
          this.changeVisibleBlock(1)
          saved = true
        }
      }, 9000)
    }
  },
  mounted () {
    this.loaded = true
  }
}
</script>

<style lang="scss" scoped>
.how-it-works {
  position: relative;
  width: 100%;
  background: #F7F9FF;
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: center;

  .container {
    height: 100%;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    padding-top: 30px;
    padding-bottom: 10px;

    > div {
      width: 100%;
    }

    .change-block {
      position: relative;

      .title {
        position: absolute;
        width: 100%;
        top: 60px;
        left: 0;
        text-align: center;
        font-weight: 700;
        font-size: 36px;
        color: #444D67;
        margin-bottom: 60px;
      }

      .content-block {
        position: absolute;
        bottom: 50px;
        width: 100%;
        height: 731px;
        text-align: center;
        display: flex;

        > div {
          width: 100%;
        }

        .left-block {
          display: flex;
          flex-direction: column;
          align-items: flex-end;
          justify-content: space-around;

          .floating-1 {
            margin-right: 50px;
          }

          .floating-2 {
            margin-right: 120px;
          }

          .floating-3 {
            margin-right: 70px;
          }
        }

        .right-block {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          justify-content: space-around;

          .floating-4 {
            margin-left: 50px;
          }

          .floating-5 {
            margin-left: 80px;
            margin-top: -110px;
          }
        }

        .floating-select-block {
          display: flex;
          flex-direction: column;
          justify-content: center;
          width: 162px;
          height: 146px;
          background: #FFFFFF;
          padding: 15px 7px 20px;
          box-shadow: 0px 0px 60px rgba(0, 0, 0, 0.1);
          border-radius: 20px;
          cursor: pointer;
          -webkit-transition: all 200ms ease-in-out;
          -moz-transition: all 200ms ease-in-out;
          -ms-transition: all 200ms ease-in-out;
          -o-transition: all 200ms ease-in-out;
          transition: all 200ms ease-in-out;

          i {
            font-size: 36px;
            color: #4AC4D0;
            margin-top: 10px;
            margin-bottom: 15px;
          }

          span {
            font-size: 16px;
            font-weight: 600;
            color: #444D67;
          }

          &.active,
          &:hover {
            background: #4AC4D0;

            i, span {
              color: #fff;
            }
          }
        }

        .center-block {
          position: relative;

          > img {
            position: absolute;
            bottom: 20px;
            left: calc(50% - 163px);

            &.animatedImgShow {
              backdrop-filter: blur(15px);
              animation: showImgBlock 0.4s 0s ease-in forwards;
            }

            &.animatedImgHide {
              backdrop-filter: blur(0px);
              animation: hideImgBlock 0.4s 1.2s ease-in forwards;
            }

            @keyframes showImgBlock {
              from {
                filter: blur(15px);
              }
              to {
                filter: blur(0px);
              }
            }

            @keyframes hideImgBlock {
              from {
                filter: blur(0px);
              }
              to {
                filter: blur(15px);
              }
            }
          }

          .top-mask {
            position: absolute;
            bottom: 5px;
            left: calc(50% - 178px);
            pointer-events: none;
          }

          .selected-block-text {
            position: absolute;
            width: 325px;
            height: 0;
            background: rgb(255,255,255);
            background: -moz-linear-gradient(top,  rgba(255,255,255,1) 1%,rgba(255,255,255,0.9) 65%, rgba(255,255,255,0) 100%);
            background: -webkit-linear-gradient(top,  rgba(255,255,255,1) 1%,rgba(255,255,255,0.9) 65%,rgba(255,255,255,0) 100%);
            background: linear-gradient(to bottom,  rgba(255,255,255,1) 1%,rgba(255,255,255,0.9) 65%,rgba(255,255,255,0) 100%);
            filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#ffffff', endColorstr='#ffffff',GradientType=0 );
            padding: 0;
            box-sizing: border-box;
            left: calc(50% - 163px);
            top: 10px;

            .separated-block {
              display: flex;
              align-items: flex-start;
              justify-content: space-between;
              text-align: left;
              margin-bottom: 25px;

              i {
                width: 25px;
                font-size: 10px;
                margin-top: 11px;
                -moz-transform: rotate(45deg);
                -webkit-transform: rotate(45deg);
                -o-transform: rotate(45deg);
                -ms-transform: rotate(45deg);
                transform: rotate(45deg);
              }

              span {
                width: calc(100% - 25px);
                color: #999;
                font-size: 15px;
              }
            }

            &.animatedShow {
              height: 0;
              padding: 0;
              animation: showWhiteBlock 0.5s 0.7s ease-in forwards;

              .icon {
                opacity: 0;
                animation: showText 0.5s 1.2s ease-in forwards;
              }
              .title {
                position: relative;
                top: 0;
                margin-bottom: 25px;
                font-size: 20px;
                opacity: 0;
                animation: showText 0.5s 1.7s ease-in forwards;
              }
              .content {
                opacity: 0;
                animation: showText 0.5s 2.2s ease-in forwards;
              }

              @keyframes showText {
                from {
                  opacity: 0;
                }
                to {
                  opacity: 1;
                }
              }
            }

            @keyframes showWhiteBlock {
              from {
                height: 0;
                padding: 0;
              }
              to {
                height: 703px;
                padding: 75px 25px;
              }
            }

            &.animatedHide {
              height: 703px;
              padding: 75px 25px;
              animation: hideWhiteBlock 0.5s 0.7s ease-in forwards;

              .icon {
                opacity: 1;
                animation: hideText 0.4s 0s ease-in forwards;
              }
              .title {
                position: relative;
                top: 0;
                margin-bottom: 25px;
                font-size: 20px;
                opacity: 1;
                animation: hideText 0.4s 0s ease-in forwards;
              }
              .content {
                opacity: 1;
                animation: hideText 0.4s 0s ease-in forwards;
              }

              @keyframes hideText {
                from {
                  opacity: 1;
                }
                to {
                  opacity: 0;
                }
              }
            }

            @keyframes hideWhiteBlock {
              from {
                height: 703px;
                padding: 75px 25px;
              }
              to {
                height: 0;
                padding: 0;
              }
            }

          }
        }
      }
    }
  }

  @media(max-width: 1150px) {
    .container .change-block .title {
      font-size: 32px;
    }

    .container .change-block .content-block .floating-select-block {
      width: 140px;
      height: 120px;

      i {
        font-size: 28px;
      }

      span {
        font-size: 14px;
      }
    }

    .container .change-block .content-block .left-block,
    .container .change-block .content-block .right-block {
      width: 23%;
    }

    .container .change-block .content-block .left-block {
      .floating-1 {
        margin-right: -30px;
      }

      .floating-2 {
        margin-right: 0px;
      }

      .floating-3 {
        margin-right: -20px;
      }
    }

    .container .change-block .content-block .right-block {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: space-around;

      .floating-4 {
        margin-left: 0px;
      }

      .floating-5 {
        margin-left: -20px;
      }
    }
  }

  @media(max-width: 980px) {
    .container .change-block .content-block .left-block {
      .floating-1 {
        margin-right: 30px;
      }

      .floating-2 {
        margin-right: 50px;
      }

      .floating-3 {
        margin-right: 40px;
      }
    }

    .container .change-block .content-block .center-block .top-mask {
      bottom: 4px;
    }

    .container .change-block .content-block .right-block {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: space-around;

      .floating-4 {
        margin-left: 25px;
      }

      .floating-5 {
        margin-left: 40px;
      }
    }
  }

  @media(max-width: 920px) {
    .container .change-block .title {
      font-size: 28px;
    }
  }

  /* CAMBIO ESTILOS SMALL */
  @media(max-width: 870px) {
    .container {
      padding-bottom: 60px;
    }

    .container .change-block .title {
      top: 25px;
    }

    .container .change-block .bottom-block {
      position: absolute;
      bottom: -10px;
      width: 100%;
      margin: 0 auto;

      i {
        margin: 0 10px;
        opacity: 0.3;
        -webkit-transition: all 200ms linear;
        -moz-transition: all 200ms linear;
        -ms-transition: all 200ms linear;
        -o-transition: all 200ms linear;
        transition: all 200ms linear;
      }

      .active {
        opacity: 1;
        -moz-transform: scale(1.1) translateY(0px);
        -webkit-transform: scale(1.1) translateY(0px);
        -o-transform: scale(1.1) translateY(0px);
        -ms-transform: scale(1.1) translateY(0px);
        transform: scale(1.1) translateY(0px);
      }
    }

    .container .change-block .content-block .left-block,
    .container .change-block .content-block .right-block {
      display: none;
    }

    .container .change-block .content-block .center-block > img {
      width: 198px;
      bottom: 11px;
      left: calc(50% - 100px);
      border-radius: 20px;
    }
    .container .change-block .content-block .center-block .top-mask {
      width: 214px;
      bottom: 3px;
      left: calc(50% - 107px);
    }

    .container .change-block .content-block .center-block .selected-block-text.animatedShow {
      width: 198px;
      height: 435px;
    }

    .container .change-block .content-block .center-block .selected-block-text {
      position: absolute;
      width: 195px;
      height: 0;
      left: calc(50% - 98px);
      bottom: -2px;
      top: auto;
      font-size: 14px;
      border-radius: 20px;

      .separated-block {
        margin-bottom: 15px;
      }

      &.animatedShow {
        height: 0;
        padding: 0;
        animation: showWhiteBlockSmall 0.5s 0.7s ease-in forwards;

        .icon {
          margin-bottom: 10px;

          i {
            font-size: 18px !important;
          }
        }

        .title {
          position: relative;
          top: 0;
          margin-bottom: 15px;
          font-size: 17px;
          opacity: 0;
        }

        span {
          font-size: 12px;
        }
      }

      @keyframes showWhiteBlockSmall {
        from {
          height: 0;
          padding: 0;
        }
        to {
          height: 435px;
          padding: 35px 15px 20px;
        }
      }

      &.animatedHide {
        height: 435px;
        padding: 35px 15px 20px;
        animation: hideWhiteBlockSmall 0.5s 0.7s ease-in forwards;

        .title {
          position: relative;
          top: 0;
          margin-bottom: 15px;
          font-size: 17px;
          opacity: 1;
          animation: hideText 0.4s 0s ease-in forwards;
        }
      }

      @keyframes hideWhiteBlockSmall {
        from {
          height: 435px;
          padding: 35px 15px 20px;
        }
        to {
          height: 0;
          padding: 0;
        }
      }
    }
  }

  @media (max-width: 550px) {
    .container .change-block .title {
        top: 5px;
    }
  }
}

@media(max-width: 1200px) {
  .how-it-works {
    font-size: 14px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/how-it-works.vue